import { render, staticRenderFns } from "./CivilStatusSetting.vue?vue&type=template&id=0c6a8cc1"
import script from "./CivilStatusSetting.vue?vue&type=script&lang=js"
export * from "./CivilStatusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports